<template>
    <div class="wrapper">
      <div class="topo-header centro">
        <botao-voltar nomeRota="CategoriaRepresentativa" />
        <h1>{{ categoriaRepresentativaForm.id ? "Editar" : "Nova" }} Entidade </h1>
      </div>
      <div class="tab-dados-basicos">
        <div class="form centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
          <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
          <form @submit.prevent="enviarForm">
            <div class="caixa-form">
              <div class="flexbox-1">
                <div class="item">
                  <label><b>{{ possuiAsterisco("Nome:") }}</b></label>
                  <input type="text" placeholder="Digite o nome" v-model="categoriaRepresentativaForm.nome" />
                </div>
                <div class="item">                  
                  <label><b>Sigla:</b></label>
                  <input type="text" placeholder="Digite a sigla" v-model="categoriaRepresentativaForm.sigla_categoria" />
                </div>
                <div class="item">
                  <div class="radio">
                    <label class="radio-label"><b>{{ possuiAsterisco("Ativa:") }}</b></label>
                    <div class="radio-item">
                        <div class="options">
                            <label for="sim-ativo-categoria">Sim</label>
                            <input type="radio" id="sim-ativo-categoria" name="radioOptions" :value=true v-model="categoriaRepresentativaForm.ativo">
                        </div>
                        <div class="options">
                            <label for="nao-ativo-categoria">Não</label>
                            <input type="radio" id="nao-ativo-categoria" name="radioOptions" :value=false v-model="categoriaRepresentativaForm.ativo">
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <img id="spinner-loading" class="spinner-loading" src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                <p id="conteudo-botao">{{ categoriaRepresentativaForm.id ? "Atualizar" : "Criar" }}</p>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div v-if="modalConfirmacaoAtualizacaoVisivel" class="modal-exclusao">
        <div class="modal-mask">
          <div class="modal-container">
            <div class="modal-header">
              <h2>Deseja realmente atualizar esta entidade?</h2>
            </div>
            <div class="modal-footer">
              <button class="btn-confirmar-exclusao" @click="confirmarAtualizacao">Sim</button>
              <button class="btn-cancelar-exclusao" @click="fecharModalConfirmacaoAtualizacao">Não</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import CategoriaRepresentativaApi from '../../services/CategoriaRepresentativaApi';
  import BotaoVoltar from '../../components/BotaoVoltar.vue';
  import MsgErroFormularios from '../MsgErroFormularios';
  
  export default {
    name: 'CategoriaRepresentativaForm',
    props: {
      categoriaRepresentativa: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        erro: false,
        msgErros: {
          nome: '',
          sigla_categoria: '',
          ativo: '',
          default: '',
        },
        categoriaRepresentativaApi: new CategoriaRepresentativaApi(),
        categoriaRepresentativaForm: this.categoriaRepresentativa
          ? {
              id: this.categoriaRepresentativa.id,
              nome: this.categoriaRepresentativa.nome,
              sigla_categoria: this.categoriaRepresentativa.sigla_categoria,
              ativo: this.categoriaRepresentativa.ativo,
            }
          : {
              id: null,
              nome: null,
              sigla_categoria: null,
              ativo: null,
            },
        modalConfirmacaoAtualizacaoVisivel: false, // Adicionado para controlar a visibilidade do modal
      };
    },
    components: {
      BotaoVoltar,
      MsgErroFormularios,
    },
    methods: {
      async enviarForm() {
        try {
          const flag = this.validarForm(this.categoriaRepresentativaForm);
          if (flag === 1) {
            this.erro = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }

          if (this.categoriaRepresentativaForm.id) {
            this.abrirModalConfirmacaoAtualizacao(); // Mostrar o modal de confirmação se estiver editando
          } else {
            await this.salvarFormulario();
          }
  
        } catch (err) {
          console.error(err);
          this.erro = true;
          const { response } = err;
          if (response && response.data) {
            this.msgErros = response.data;
          } else {
            this.msgErros = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
          }
        }
      },
      async salvarFormulario() {
        try {
          const data = await this.categoriaRepresentativaApi.setCategoriaRepresentativa(this.categoriaRepresentativaForm);
          // Redirecionar para a rota de visualização após a submissão bem-sucedida
          this.$router.push({
            name: 'CategoriaRepresentativaShow',
            params: {
              id: data.id,
            },
          });
        } catch (err) {
          console.error(err);
          this.erro = true;
          const { response } = err;
          if (response && response.data) {
            this.msgErros = response.data;
          } else {
            this.msgErros = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
          }
        }
      },
      confirmarAtualizacao() {
        this.salvarFormulario(); // Salva o formulário após confirmação
        this.fecharModalConfirmacaoAtualizacao();
      },
      abrirModalConfirmacaoAtualizacao() {
        this.modalConfirmacaoAtualizacaoVisivel = true;
      },
      fecharModalConfirmacaoAtualizacao() {
        this.modalConfirmacaoAtualizacaoVisivel = false;
      },
      validarForm(categoriaRepresentativaForm) {
        let flag = 0;
        this.msgErros = {
          nome: '',
          ativo: '',
          default: '',
        };
  
        if (!categoriaRepresentativaForm.nome) {
          this.msgErros.nome = 'O campo nome não foi preenchido.';
          flag = 1;
        }
        if (categoriaRepresentativaForm.ativo === null) {
          this.msgErros.ativo = 'O campo ativa não foi preenchido.';
          flag = 1;
        }
  
        return flag;
      },
      possuiAsterisco(texto) {
        return '* ' + texto;
      },
      fecharErro() {
        this.erro = false;
      },
    },
  };
</script>
  
<style lang="scss" scoped>
@import "../../styles/catalogoForm.scss";

/*  ESTILOS DO MODAL DE ATUALIZAÇÃO */
.modal-exclusao {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 10000;
    width: fit-content; 
    min-width: 400px;
    max-height: 90vh; 
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column; 
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  }

  .modal-container {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header {
      margin-bottom: 1.5rem;
      h2 {
        font-size: 1.3rem;
        font-weight: bold;
        text-align: center;
        margin: 0;
        color: #333;
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 0;
      flex-shrink: 0;
      gap: 1rem;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 120px;
        height: 2.5rem;
        background-color: #005516; 
        color: #ffffff;
        font-weight: bold;
        font-size: 1rem;
        cursor: pointer;
        transition: 0.2s;
        &:hover { background-color: #003a0f; }
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 120px;
        height: 2.5rem;
        background-color: #bd0000;
        color: #ffffff;
        font-weight: bold;
        font-size: 1rem;
        cursor: pointer;
        transition: 0.2s;
        &:hover { background-color: #8c0000; }
      }
    }
  }
}
.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
</style>
